import { render, staticRenderFns } from "./InvoiceDesktopView.vue?vue&type=template&id=4e552c38&"
import script from "./InvoiceDesktopView.vue?vue&type=script&lang=js&"
export * from "./InvoiceDesktopView.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceDesktopView.vue?vue&type=style&index=0&id=4e552c38&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports